//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import { getConfig, addFile } from '@/api/wx.js'
// import { WeixinConfigServlet, UploadWeiXinPicServlet } from '@/api/user.js'
import { getOrderView } from '@/api/integralmall'
import { evaluate } from '@/api/mall'
import config from '@/config/index'
export default {
  name: 'evaluate',
  props: {},
  data () {
    return {
      obj: '',
      baseUrl: config.baseUrl,
      id: this.$route.params.orderid,
      eva: '',
      eva2: '',
      eva3: '',
      score: 0,
      score2: 0,
      score3: 0,
      reason: '',
      photoObj: {
        imgcount: 6,
        imglist: [],
        fileUrlArr: []
      },
      showbutton: true
    }
  },
  computed: { // 计算属性
    itemClasses () {
      let result = [] // 返回的是一个数组,用来遍历输出星星
      let score = Math.floor(this.score * 2) / 2 // 计算所有星星的数量
      let integer = Math.floor(score) // 整数星星判断
      for (let i = 0; i < integer; i++) { // 整数星星使用on
        result.push('on') // 一个整数星星就push一个CLS_ON到数组
      }
      while (result.length < 5) { // 余下的用无星星补全,使用off
        result.push('off')
      }
      return result
    },
    itemClasses2 () {
      let result = [] // 返回的是一个数组,用来遍历输出星星
      let score2 = Math.floor(this.score2 * 2) / 2 // 计算所有星星的数量
      let integer = Math.floor(score2) // 整数星星判断
      for (let i = 0; i < integer; i++) { // 整数星星使用on
        result.push('on') // 一个整数星星就push一个CLS_ON到数组
      }
      while (result.length < 5) { // 余下的用无星星补全,使用off
        result.push('off')
      }
      return result
    },
    itemClasses3 () {
      let result = [] // 返回的是一个数组,用来遍历输出星星
      let score3 = Math.floor(this.score3 * 2) / 2 // 计算所有星星的数量
      let integer = Math.floor(score3) // 整数星星判断
      for (let i = 0; i < integer; i++) { // 整数星星使用on
        result.push('on') // 一个整数星星就push一个CLS_ON到数组
      }
      while (result.length < 5) { // 余下的用无星星补全,使用off
        result.push('off')
      }
      return result
    },
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  created () { },
  mounted () {
    this.getOrderViewNow()
    this.wxconfig()
    var h = document.body.scrollHeight
    window.onresize = () => {
      if (document.body.scrollHeight < h) {
        this.showbutton = false
      } else {
        this.showbutton = true
      }
    }
  },
  methods: {
    onblur (val, $event) {
      window.scroll(0, 0)
      document.activeElement.scrollIntoViewIfNeeded(true)
    },
    getOrderViewNow () {
      getOrderView({
        orderid: this.id
      }).then(data => {
        this.obj = data.returnValue
      })
    },
    stars (index) {
      this.score = index + 1
      if (this.score === 0) {
        this.eva = ''
      } else if (this.score === 1) {
        this.eva = '非常差'
      } else if (this.score === 2) {
        this.eva = '差'
      } else if (this.score === 3) {
        this.eva = '一般'
      } else if (this.score === 4) {
        this.eva = '好'
      } else {
        this.eva = '非常好'
      }
    },
    stars2 (index) {
      this.score2 = index + 1
      if (this.score2 === 0) {
        this.eva2 = ''
      } else if (this.score2 === 1) {
        this.eva2 = '非常差'
      } else if (this.score2 === 2) {
        this.eva2 = '差'
      } else if (this.score2 === 3) {
        this.eva2 = '一般'
      } else if (this.score2 === 4) {
        this.eva2 = '好'
      } else {
        this.eva2 = '非常好'
      }
    },
    stars3 (index) {
      this.score3 = index + 1
      if (this.score3 === 0) {
        this.eva3 = ''
      } else if (this.score3 === 1) {
        this.eva3 = '非常差'
      } else if (this.score3 === 2) {
        this.eva3 = '差'
      } else if (this.score3 === 3) {
        this.eva3 = '一般'
      } else if (this.score3 === 4) {
        this.eva3 = '好'
      } else {
        this.eva3 = '非常好'
      }
    },
    // 微信权限配置
    wxconfig () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if (
        ua.match(/MicroMessenger/i) == 'micromessenger' &&
        ua.match(/wxwork/i) == 'wxwork'
      ) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = this.$store.state.user.wechatSignUrl
        // alert('微信客户端')
      }
      getConfig({
        url: href
      }).then(re => {
        var configs = re.returnValue
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configs.appId, // 必填，公众号的唯一标识
          timestamp: configs.timestamp, // 必填，生成签名的时间戳
          nonceStr: configs.nonceStr, // 必填，生成签名的随机串
          signature: configs.signature, // 必填，签名，见附录1
          jsApiList: ['previewImage', 'chooseImage', 'uploadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      })
    },
    // 拍照或从手机相册中选图接口
    chooseFile (imglist, imgcount) {
      let count = imgcount - imglist.length
      console.log('Touch')
      //   alert('拍照接口')
      var _this = this
      wx.chooseImage({
        count: count, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: res => {
          var localIds = res.localIds
          _this.index = 0
          if (localIds.length > 0) {
            _this.uploadFile(imglist, localIds)
          }
        },
        fail: res => {
          console.log('失败')
        },
        complete: res => {
          console.log('gg')
        }
      })
    },
    // 上传图片到微信
    uploadFile (imglist, localIds) {
      var _this = this
      if (_this.index >= localIds.length) {
        return
      }
      wx.uploadImage({
        localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
        success: res => {
          addFile({
            mediaId: res.serverId
          }).then(re => {
            imglist.push(re.returnValue)
            _this.photoObj.fileUrlArr.push(re.returnValue.filepath)
            _this.index++
            _this.uploadFile(imglist, localIds)
          })
        }
      })
    },
    // 图片放大
    preview (index, fileList) {
      let arr = fileList.map(item => this.baseUrl + item)
      wx.previewImage({
        current: arr[index], // 当前显示图片的http链接
        urls: arr // 需要预览的图片http链接列表
      })
    },
    del (index) {
      this.photoObj.imglist.splice(index, 1)
    },
    submit () {
      if (this.score === 0 || this.score2 === 0 || this.score3 === 0) {
        this.$vux.toast.text('请打星', 'middle')
        return false
      }
      // if (this.reason.length === 0) {
      //   this.$vux.toast.text('请填写评价', 'middle')
      //   return false
      // }
      let picids = this.photoObj.imglist.map(item => item.id)
      picids = picids.join(';')
      console.log(picids)
      evaluate({
        orderid: this.id,
        productid: this.obj.PRODUCTID,
        reason: this.reason,
        paths: picids,
        num1: this.score,
        num2: this.score2,
        num3: this.score3,
        accountid: this.accountid
      }).then(res => {
        if (res.success) {
          let _this = this
          this.$vux.alert.show({
            content: '发布成功',
            onHide () {
              window.history.back()
            }
          })
        }
      })
    }
  }
}
